import { createApp, watch } from 'vue';
import App from './App.vue';
import router from './router';
import i18n, { initialLocale } from './i18n';
import { primeVueLocales } from './i18n/primevue-locales';
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import { definePreset } from '@primevue/themes';
import { Tooltip } from 'primevue';

import 'primeicons/primeicons.css';
import './assets/vlecad-theme.css';

const VlecadAura = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#edf7fc',
            100: '#dcecf4',
            200: '#bdddea',
            300: '#8fc7dd',
            400: '#58abd0',
            500: '#0d74ac',
            600: '#095f8d',
            700: '#084f75',
            800: '#12364a',
            900: '#102f40',
            950: '#091c27'
        },
        focusRing: {
            width: '3px',
            style: 'solid',
            color: '#0d74ac',
            offset: '2px'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '#f4f5f4',
                    100: '#ecefee',
                    200: '#d9dde0',
                    300: '#c3c9cd',
                    400: '#929ba1',
                    500: '#696f78',
                    600: '#4d535c',
                    700: '#3d4049',
                    800: '#243f4e',
                    900: '#12364a',
                    950: '#091c27'
                },
                primary: {
                    color: '#0d74ac',
                    contrastColor: '#ffffff',
                    hoverColor: '#095f8d',
                    activeColor: '#12364a'
                },
                highlight: {
                    background: '#dcecf4',
                    focusBackground: '#cbe4f0',
                    color: '#12364a',
                    focusColor: '#095f8d'
                }
            }
        }
    }
});

const app = createApp(App);
app.directive('tooltip', Tooltip);

app.config.globalProperties.baseUrl = process.env.VUE_APP_API_URL;
app.config.globalProperties.myvlecadUrl = process.env.VUE_APP_MYVLECAD_BASE_URL;

app.use(router);
app.use(i18n);
app.use(PrimeVue, {
    theme: {
        preset: VlecadAura
    },
    locale: primeVueLocales[initialLocale]
});

const primeVue = app.config.globalProperties.$primevue;
watch(i18n.global.locale, (locale) => {
    const messages = primeVueLocales[locale] || primeVueLocales.nl;
    primeVue.config.locale = { ...messages, aria: { ...messages.aria } };
});

app.mount('#app');
